module.exports = __webpack_public_path__ + "static/media/user.4c2fb49e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/user.svg
// module id = 491
// module chunks = 0